import { serviceBackgroundChecks } from "./serviceBackgroundChecks";
import { IBackgroundCheckSettingsResponse } from "@wingspanhq/background-checks/dist/lib/interfaces";

export const getBackgroundChecksSettings = async (
  settingsId: string
): Promise<IBackgroundCheckSettingsResponse> => {
  const { data } = await serviceBackgroundChecks.get(`/settings/${settingsId}`);
  return data;
};
